import { Moment } from "moment";
import { agent } from '@shared/services/agent';
import { OfficeEntity } from '@features/desks/services/AdvanceHotDeskingService';
import { DATE_FORMAT, PRETTY_DATE_FORMAT } from '@shared/utils/DateUtils';
import { toCsvDownload } from '@features/reporting/services/ReportingService';

export async function loadDailyReport(date: Moment, office: OfficeEntity): Promise<any> {
  const data = await agent.requests.get(`/api/v2/hospitality/report/daily?office=${office.id}&date=${date.format(DATE_FORMAT)}`)
  toCsvDownload(data, `meeting room hospitality for ${date.format(PRETTY_DATE_FORMAT)}`);
}

export async function loadWeeklyReport(date: Moment, office: OfficeEntity): Promise<any> {
  const data = await agent.requests.get(`/api/v2/hospitality/report/weekly?office=${office.id}&date=${date.format(DATE_FORMAT)}`)
  toCsvDownload(data, `meeting room hospitality w/c ${date.format(PRETTY_DATE_FORMAT)}`);
}

export async function loadMonthlyReport(date: Moment, office: OfficeEntity): Promise<any> {
  const data = await agent.requests.get(`/api/v2/hospitality/report/monthly?office=${office.id}&date=${date.format(DATE_FORMAT)}`)
  toCsvDownload(data, `meeting room hospitality m/c ${date.format(PRETTY_DATE_FORMAT)}`);
}
